import type { Env } from '@/types';

export interface EnvEndpoints {
  /** Origin only — e.g. `https://api.libertify.com`. Paths are mounted at
   *  several different prefixes:
   *    `/api/...`   — auth, organizations, workspaces, transfer-tokens
   *    `/media/...` — projects, documents, assets, media generation
   *  Each `RequestSpec.path` therefore carries its own prefix.
   */
  apiBase: string;
  cognitoDomain: string;
  cognitoClientId: string;
  websocket: string;
}

export const ENDPOINTS: Record<Env, EnvEndpoints> = {
  production: {
    apiBase: 'https://api.libertify.com',
    cognitoDomain: 'auth.libertify.com',
    cognitoClientId: 'kv03p4cru7q0k5gtc38thmrmo',
    websocket: 'wss://websocket.libertify.com',
  },
  staging: {
    apiBase: 'https://api.staging.libertify.com',
    cognitoDomain: 'auth.libertify.com',
    cognitoClientId: 'kv03p4cru7q0k5gtc38thmrmo',
    websocket: 'wss://websocket.staging.libertify.com',
  },
  development: {
    apiBase: 'https://api.dev.libertify.com',
    cognitoDomain: 'auth.dev.libertify.com',
    cognitoClientId: '54ac2k5n7f57es2ec26g07astdj40',
    websocket: 'wss://websocket.dev.libertify.com',
  },
};

export function getEndpoints(env: Env): EnvEndpoints {
  return ENDPOINTS[env];
}
